import {IEnvironment} from "./ienvironment";

export const environment:IEnvironment = {
  production: true
  ,applicationLogo: "/assets/images/logo-apsats.png"
  ,applicationLogoTitle: "APSATS in partnership with Discover and Change."
  ,applicationTitle: "APSATS' Intake System"
  ,token: "$4$lgKbEwkQ$GhMIJm5EYKhOMxM3w1D4ZazndK4$"
  ,stripePublicKey: "pk_test_jacXtSqKTpXcj1FNpmlcl3Tf"
  ,stripeChargeName: "APSATS"
  ,features: {
    "client.add": true
    // can you add/edit see the list of assessments on the assessment admin page.
    ,"assessments.manage": true
    ,"assessments.reports.manage": true
    // does the navigation link to the assessments admin show up
    ,"admin.assessments.navigation": true
    // the link back to addo's home page.
    ,"addo.dashboard.admin": true
    // can batteries be added, displayed, managed, etc.
    ,"assessments.battery.manage": true
    // does the client edit assessment email template display
    ,"assessments.manage.emailtemplate": true
    ,"wordpress.auth.check": false
    ,"admin.shop": true
    ,"assessments.tokens.enabled": true
  }
  ,useAddoReports: false
  // ,apiURL: "http://discoverandchange.development:8000/api/v1/"

  ,apiURL: "https://assessment-api-beta.discoverandchange.com/api/v1/"
  // ,apiURL: "http://localhost:8000/api/v1/"
  ,supportEmail: "info@discoverandchange.com"
  ,supportPhone: "(385) 233-9626"
  ,skinClasses: ['aqua-green-skin', 'apsats-skin']
  ,navBarClass: 'navbar-light'
  ,reportHeaderImgURL: "/assets/images/logo-apsats.png"
  ,partners: ['discoverandchange']
  ,disabledAssessments: ['2502']
  ,copyrightURL: "https://www.apsats.org/"
  ,copyrightTitle: "APSATS"
  ,awsCognitoConfig: {
    awsCognitoRegion: 'us-east-1',
    userPool: {
      userPoolsId:"us-east-1_wZbWCIog6",
      webClientId:"137s98m2bl96pf4ibbha49qsd4"
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts